import { Loader } from "@/shared/components/master-page/loader";
import { NgOpenPageRequest, NgGamesLobbyOpenPage } from "@/shared/model/ng/ng-open-page-request";
import { NgOpenPageResponse } from "@/shared/model/ng/ng-open-page-response";
import { sazkaAlert } from "@/shared/composables/use-sazka-alert";
import { useGdpr } from "@/shared/composables/use-gdpr";
import { logException } from "@/shared/utils/logger/use-app-logger";
import { kenticoHttpClient } from "@/api/kentico-http-client";
import analytics from "../analytics";
export async function ngOpenPage(key: string, customInfo: string | Record<string, unknown>) {
    // total fallback
    let url: string = null;
    let blank = false;
    key = typeof key === "string" ? key.toLowerCase() : key;
    customInfo = typeof customInfo === "string" ? customInfo.toLowerCase() : customInfo;
    const customInfoObj = customInfo as Record<string, unknown>;

    // ignore solo gameslobby - it happens when user recarges money and then clicks "Zpět do nabídky her"
    // in this case user can miss screen "your bet has been placed"
    if (key === "gameslobby" && !customInfo) return;

    switch (key) {
        // ticket detail from NG's popups
        case "externalbetdetails":
            url = `/moje-sazky/detail/${customInfoObj.GameInstanceID as number}`;
            break;

        // preference center - PR
        case "preferencecenter":
            url = useGdpr().getLinkToPrefCenter();
            blank = true;
            break;

        case "playerlimitedaccess":
            ng_fw.getPlayerRestrictions((restrictions) => {
                const isRestricted = restrictions.some((x) => x.reasonId == 129); // ReasonID 129

                if (isRestricted) {
                    sazkaAlert({
                        title: "Omezení online hraní",
                        subText:
                            "Je nám líto, ale na základě zákona o hazardních hrách vám nadále nemůžeme umožnit online sázení na herním portálu Sazka.cz. Výběry z vašeho účtu jsou možné.",
                        linkText: "Více informací",
                        link: `/centrum-podpory/online-hrani-na-sazka-cz/muj-ucet/rejstrik-vyloucenych-osob`,
                        btnCloseText: "Rozumím",
                    });
                    analytics.sendErrorEvent(
                        "Je nám líto, ale na základě zákona o hazardních hrách vám nadále nemůžeme umožnit online sázení na herním portálu Sazka.cz. Výběry z vašeho účtu jsou možné.",
                        "pop-up",
                    );
                }
            });

            return;

        case "rglimits":
            url = "/?rg-limits=true";
            break;

        default:
            Loader.show();
            try {
                const response = await kenticoHttpClient.get<NgOpenPageResponse>("/api/ng/open-page", {
                    params: makeRequest(key, customInfo),
                });
                url = response.data.url;
                blank = response.data.openMode === "new";
            } catch (error) {
                logException("neogames", error, { message: "Error while calling ngOpenPage" });
            }
    }

    if (!url) {
        // default
        url = "/centrum-podpory";
    }

    if (blank) {
        Loader.hide();
    }

    // make it absolute
    url = url.startsWith("/") ? `${environment.portalBaseUrl}${url}` : url;
    window.open(url, blank ? "_blank" : "_self");
}

function makeRequest(
    key: string,
    customInfo: string | Record<string, string> | NgGamesLobbyOpenPage,
): NgOpenPageRequest {
    if (key == "gameslobby") {
        const info = customInfo as NgGamesLobbyOpenPage;
        return {
            key,
            verticals: info.verticals.join("|"),
            provider: info.provider?.toLowerCase(),
            subProvider: info.subprovider?.toLowerCase(),
        };
    } else {
        return {
            key,
            info: customInfo?.toString(),
        };
    }
}
